import Plausible from "plausible-tracker";

const urlParams = new URLSearchParams(window.location.search);
const pathArray = window.location.pathname.split("/");

// Handle new URL structure: /:team/trip/:permalink/:id or /:team/atlas/:permalink/:id
let typeID, trprID;

if (pathArray.length >= 4) {
    // New URL structure
    const typeSegment = pathArray[2] || null; // 'trip' or 'atlas'
    const idSegment = pathArray[4] || null;
    
    trprID = urlParams.get("id") || idSegment;
    typeID = urlParams.get("type") || typeSegment;
} else {
    // Handle existing URL structure by passing through the current path
    const typeSegment = pathArray[1] || null;
    const idSegment = pathArray[2] || null;
    trprID = urlParams.get("id") || idSegment;
    typeID = urlParams.get("type") || typeSegment;
}

export default function TrackPageView(appDomain, typeID) {
    //Plausible Tracking
    const { trackPageview } = Plausible({
        domain: appDomain,
        trackLocalhost: true,
    });
    
    // Construct the tracking URL based on the current page structure
    const trackingUrl = constructTrackingUrl(typeID, trprID);
    trackPageview({ url: trackingUrl });
}

function constructTrackingUrl(typeID, trprID) {
    const pathArray = window.location.pathname.split("/");
    
    if (pathArray.length >= 4) {
        // New URL structure: /:team/trip/:permalink/:id or /:team/atlas/:permalink/:id
        const teamSegment = pathArray[1] || 'tripper';
        const typeSegment = pathArray[2] || typeID; // 'trip' or 'atlas'
        const permalinkSegment = pathArray[3] || 'item';
        
        return `https://maps.northernontario.travel/${teamSegment}/${typeSegment}/${permalinkSegment}/${trprID}`;
    } else {
        // Pass through the existing URL structure
        return `https://maps.northernontario.travel${window.location.pathname}`;
    }
}

export function trackOutboundClick(appDomain, url) {
    const { trackEvent } = Plausible({
        domain: appDomain,
        trackLocalhost: true,
    });

    // Tracks the 'Outbound Click' Goal
    const trackingUrl = constructTrackingUrl(typeID, trprID);
    trackEvent(
        "Outbound Link: Click",
        {
            props: {
                url: url,
            },
        },
        { trackLocalhost: true, url: trackingUrl },
    );
}

export function trackStopInView(appDomain, stopLabel) {
    const { trackEvent } = Plausible({
        domain: appDomain,
        trackLocalhost: true,
    });

    // Tracks the Scroll Depth Goal
    const trackingUrl = constructTrackingUrl(typeID, trprID);
    trackEvent(
        "Stop: Scroll in View",
        {
            props: {
                stop: stopLabel,
            },
        },
        { trackLocalhost: true, url: trackingUrl },
    );
}
